import {
  AGE_RANGE_REGEX,
  GENDER_REGEX,
  HOMEOWNER_REGEX,
  INCOME_REGEX,
  MAIN_SHOPPER_REGEX,
  TARGET_AUDIENCE,
  UNSPECIFIED
} from '../constants';
import { DemographicItem } from '../types';

const mapDemographics = (demographic: TARGET_AUDIENCE): DemographicItem[] => {
  const demographicItems: DemographicItem[] = [];

  const age = extract(demographic, AGE_RANGE_REGEX);
  addDemographicItem('Demo', age, demographicItems);

  const gender = extract(demographic, GENDER_REGEX);
  addDemographicItem('Gender', gender, demographicItems);

  const income = extract(demographic, INCOME_REGEX);
  addDemographicItem('Income', income, demographicItems);

  const homeowner = isHomeowner(demographic);
  addDemographicItem('Home Ownership', homeowner, demographicItems);

  const mainShopper = isMainShopper(demographic);
  addDemographicItem('Is the Main Shopper', mainShopper, demographicItems);

  formatDemographicItems(demographicItems);

  return demographicItems;
};

const formatDemographicItems = (item: DemographicItem[]): DemographicItem[] => {
  while (item.length <= 6) {
    item.push({ title: '', content: '' });
  }

  return item;
};

const addDemographicItem = (
  title: string,
  value: string,
  items: DemographicItem[]
) => {
  if (value !== UNSPECIFIED) {
    items.push({ title, content: value });
  }
};

const extract = (demographic: TARGET_AUDIENCE, regex: RegExp): string => {
  const match = demographic.match(regex);
  return match ? match[0] : UNSPECIFIED;
};

const isHomeowner = (demographic: TARGET_AUDIENCE): string => {
  const isHomeownerDemographic = HOMEOWNER_REGEX.test(demographic);
  return isHomeownerDemographic ? 'Is a Homeowner' : UNSPECIFIED;
};

const isMainShopper = (demographic: TARGET_AUDIENCE): string => {
  const isMainShopperDemographic = MAIN_SHOPPER_REGEX.test(demographic);
  return isMainShopperDemographic ? 'Is the Main Shopper' : UNSPECIFIED;
};

export default mapDemographics;
